'use strict';

$('body').on('click tap', '.js-youtube-embed', function () {
  var $this = $(this);
  var youtubeId = $this.data('youtube-id');
  var iframe =
    '<iframe id="js-youtube-embed" src="//www.youtube.com/embed/' +
    youtubeId +
    '?rel=0&amp;autoplay=true&amp;wmode=transparent" frameborder="0" allowfullscreen="allowfullscreen"></iframe>';
  $this.append(iframe);
});
